/**
 * AsoExpertBadge Component
 *
 * Small inline badge indicating that recommendations come from
 * Apptonomy's ASO expert analysis engine. Used on the primary
 * recommendation sections throughout the audit report.
 */

import { SparklesIcon } from '@heroicons/react/20/solid';

export function AsoExpertBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2.5 py-0.5 text-xs font-medium text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300 ${className}`}
    >
      <SparklesIcon className="size-3" />
      ASO Best Practices
    </span>
  );
}
